import React from 'react';

import VectorMap, {
  Layer,
  Label,
  Tooltip,
  Legend,
  Source,
  ControlBar,
} from 'devextreme-react/vector-map';

import BarTooltipTemplate from './barTooltip.js';
import { kafue } from './kafue.js';
const bounds = [-180, 85, 180, -60];
const colorGroups = [-90, -15, 0, 15, 90];
const streamsPalette = ['#D32F2F', '#FFA000', '#00802b', '#00e64d'];
const streamsNames = {
  '#d32f2f': '> 15% Decrease',
  '#ffa000': '0 - 15% Decrease',
  '#00802b': '0 - 15% Increase',
  '#00e64d': '> 15% Increase'
};
const center = [27.056250000000038, -13.020828131543004];
var electionData = {};

export default function MapRegistration({ data = [] }) {

  // Update the document title using the browser API
  electionData = data;

  kafue.features.forEach(item => {

    const mdata = electionData[item.properties.fid];

    if (mdata) {

      item.properties.name = mdata.name;
      item.properties.change = mdata.registeredChange;
      item.properties.data = mdata;
    } else {
      item.properties.name = item.properties.fid;
      item.properties.change = 0;
    }

  });

  const clickHandler = ({ target }) => {

    if (target) {
      console.log("Clicked", target.attribute('fid'));
      target.selected(!target.selected());
    }
  }

  const customizeText = (arg) => {

    //console.log(arg);
    return streamsNames[arg.color];
  }

  const zoomFactorChanged = ({ zoomFactor }) => {
    console.log("zoom has changed");
    console.log(zoomFactor);
  };

  return (
    <div>
      <VectorMap
        id="vectorMap"
        zoomFactor={25}
        bounds={bounds}
        center={center}
        zoomFactorChanged={zoomFactorChanged}
        onClick={clickHandler}>
        <ControlBar enabled={true}>
        </ControlBar>
        <Layer
          name='zambia'
          dataSource={kafue}
          colorGroupingField="change"
          colorGroups={colorGroups}
          palette={streamsPalette}
        >
          <Label dataField="name" enabled={true} font={{ size: 8 }} />
        </Layer>
        <Tooltip enabled={true} data={data}
          contentRender={BarTooltipTemplate} />
        <Legend
          title='Registered Voters Change'
          horizontalAlignment="center"
          verticalAlignment="bottom"
          visible={true}
          customizeText={customizeText}>
          <Source layer="zambia" grouping="color"></Source>
        </Legend>
      </VectorMap>

    </div>
  );
}






